module.exports = __webpack_public_path__ + "static/media/medal-stone.1a8123cd.png";